/*
 * CustomCssAnimation
 *
 * Use this to create animation wrappers that start and end in the same pose.
 * The animation is run by apply CSS classes at various timings - The CSS classes being passed in as a useStyles object.
 * Animations built with this component won't play on mount.
 */

import PropTypes from 'prop-types';
import React from 'react';
import { useState } from 'react';
import clsx from 'clsx';
import { Transition } from 'react-transition-group';

//////////////////////////

const propTypes = {
  children: PropTypes.any.isRequired,
  useStyles: PropTypes.func.isRequired,
};

export const CustomCssAnimation = props => {

  const [isActive, setIsActive] = useState(false);
  const {
    children,
    useStyles,
  } = props;
  const styles = useStyles();

  // Delay exit animation
  const queueExit = (delay) => {
    setTimeout(() => setIsActive(false), delay);
  }

  // Define control functions
  const short = () => {
    setIsActive(true);
    queueExit( 500 );
  }
  const medium = () => {
    setIsActive(true);
    queueExit( 1500 );
  }
  const long = () => {
    setIsActive(true);
    queueExit( 3000 );
  }
  const on = () => {
    setIsActive(true);
  }
  const off = () => {
    setIsActive(false);
  }
  const toggle = () => {
    setIsActive(!isActive);
  }

  // FIXME: This runs everytime. It should only run on mount.
  // Link to controls
  if(props.setControls) {
    let id = props.id || "custom";
    // Pass key and controls back to calling component
    props.setControls(id, {
      short,
      medium,
      long,
      on,
      off,
      toggle,
    });
  }

  //////
  
  return (

    <Transition
      in = {isActive}
      timeout = {0} // Animators transition on/off instantaneously
    >
    {state => (
      <div
        className = {clsx( styles.default, styles.transitions, state )}
        style = {{
          width: 'fit-content', // TODO: Not usable on IE and possibly not consistent in other browsers - test and find solution where necessary
        }}
        >
        {children}
      </div>
    )}
    </Transition>

  );

};

CustomCssAnimation.propTypes = propTypes;
export default CustomCssAnimation;